export default __webpack_public_path__ + "static/media/texture.3e0702f2.png";